import {
  PossibleFilterValues,
  ResourceExplorerGroupingLabel,
  ResourceExplorerGroupingNullable,
} from "@/services/cloudchipr.api";

interface GenerateBillingExplorerGroupingLabelArgs {
  grouping: ResourceExplorerGroupingNullable;
  groupValues?: string[];
  groupingLabel?: ResourceExplorerGroupingLabel;
  dimensionPossibleFilters?: PossibleFilterValues;
  enableCategoryGroupingFilterV2: boolean;
}
export const generateBillingExplorerGroupingLabel = ({
  dimensionPossibleFilters,
  grouping,
  enableCategoryGroupingFilterV2,
  groupValues,
  groupingLabel,
}: GenerateBillingExplorerGroupingLabelArgs) => {
  const categoryGroupKey = enableCategoryGroupingFilterV2
    ? "category_v2"
    : "category";

  const firstValue = groupValues?.at(0);

  const selected = dimensionPossibleFilters?.find((option) => {
    if (enableCategoryGroupingFilterV2) {
      return option.title === firstValue;
    }
    return option.value === firstValue;
  });

  const dimensionName = selected?.title ?? selected?.value ?? "";
  return grouping === categoryGroupKey
    ? dimensionName
    : groupingLabel?.singular;
};
